import { groq } from 'next-sanity';
import { z } from 'zod';

import { basicText, SanityBasicText } from './basicText';
import { cardButton, SanityCardButton } from './buttonRow';

export const SanityHeroCentered = z.object({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('heroCentered'),
  _key: z.string(),
  theme: z.enum(['purple', 'charcoal', 'white']),
  backgroundPattern: z.string().optional().nullable(),
  eyebrow: z.string().optional().nullable(),
  title: z.string(),
  description: SanityBasicText.optional().nullable(),
  buttons: z.array(SanityCardButton).optional().nullable(),
  mascot: z
    .enum([
      'none',
      'peek-teal-ul-then-lime-lr',
      'peek-lime-lr',
      'peek-purple-ll',
      'bounce-teal-bottom-to-cta',
      'roll-purple-bottom',
      'peek-purple-ul-then-teal-lc',
    ])
    .optional()
    .nullable(),
});
export type SanityHeroCentered = z.infer<typeof SanityHeroCentered>;

export const heroCentered = groq`{
  theme,
  'backgroundPattern': background,
  eyebrow,
  title,
  description[] ${basicText},
  buttons[] ${cardButton},
  'mascot': coalesce(mascot, 'none'),
}`;
